import Logout from './Logout';

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout/index.js